import * as actionTypes from "./actionTypes";

export const AttachmentInteractionInit = (chatId) => ({
  type: actionTypes.ATTACHMENTS_INTERACTION_INIT,
  payload: { chatId },
});

export const handleActiveAttachment = (chatId, data) => ({
  type: actionTypes.HANDLE_ACTIVE_ATTACHMENT,
  payload: { chatId, data },
});

export const handleOpenTab = (chatId, name) => ({
  type: actionTypes.HANDLE_OPEN_TAB,
  payload: { chatId, name },
});

export const getAttachmentsList = (chatId) => ({
  type: actionTypes.GET_ATTACHMENTS_LIST,
  payload: { chatId },
});

export const getAttachmentsListSuccess = (chatId, data) => ({
  type: actionTypes.GET_ATTACHMENTS_LIST_SUCCESS,
  payload: { chatId, data },
});

export const getAttachmentsListFailure = (chatId, error) => ({
  type: actionTypes.GET_ATTACHMENTS_LIST_FAILURE,
  payload: { chatId, error },
});

export const resetAttachmentsInteraction = (chatId) => ({
  type: actionTypes.RESET_ATTACHMENTS_INTERACTION,
  payload: { chatId },
});

export const updateAttachmentStatus = (data) => ({
  type: actionTypes.UPDATE_ATTACHMENT_STATUS,
  payload: data,
});

export const updateAttachmentStatusSuccess = (chatId, data) => ({
  type: actionTypes.UPDATE_ATTACHMENT_STATUS_SUCCESS,
  payload: { chatId, ...data },
});

export const updateAttachmentStatusFailure = (chatId, error) => ({
  type: actionTypes.UPDATE_ATTACHMENT_STATUS_FAILURE,
  payload: { chatId, error },
});

export const uploadAttachments = (data) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS,
  payload: data,
});

export const uploadAttachmentsSuccess = (data) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_SUCCESS,
  payload: data,
});

export const uploadAttachmentsFailure = (data, error) => ({
  type: actionTypes.UPLOAD_ATTACHMENTS_FAILURE,
  payload: { ...data, error },
});

export const downloadAttachmentStart = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_START,
  payload: {},
})

export const downloadAttachmentEnd = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_END,
  payload: {},
})

export const requesResetMessageToaste = () => ({
  type: actionTypes.RESET_MESSAGE_TOASTE,
  payload: {},
});

export const requestAttachment = (data) => ({
  type: actionTypes.REQUEST_ATTACHMENT,
  payload: data,
});

export const requestAttachmentSuccess = (data) => ({
  type: actionTypes.REQUEST_ATTACHMENT_SUCCESS,
  payload: data,
});

export const requestAttachmentFailure = (data) => ({
  type: actionTypes.REQUEST_ATTACHMENT_FAILURE,
  payload: data,
});
